<template>
  <div >
    <div class="text-center text-xl mt-4">
       I {{feelText}} <span class="font-bold">{{moodText}}</span>
        <ThanksTo  :thanksTo="story.whyDoYouFeelThatWay" />.
    </div>
    <div class="flex justify-center">
      <div class="w-3/4">
        <vs-progress
          :height="5"
          :percent="story.mood * 10"
          color="primary"
          />
        <div class="flex text-grey">
         <div class="flex justify-start w-1/2">
            not so good
         </div>
         <div class="flex justify-end w-1/2">
            good
         </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
// import JourneyDay from './JourneyDay'
import * as DateHelper from '@/helpers/date'
import _ from 'lodash'
import Story from '@/models/Story'
import ThanksTo from './ThanksTo'


export default {
  components: {
    ThanksTo
  },
  props: ['story'],
  data () {
    return {
    }
  },
  computed: {
    feelText () {
      return this.isToday ? "feel" : "felt"
    },
    isToday () {
      return DateHelper.ensuredDateEqual(this.story.deadline, this.$store.getters.today)
    },
    showSentiment () {
      return this.storyEntity.sentiment()
    },
    storyEntity () {
      return new Story(this.story)
    },
    moodText () {
      return this.storyEntity.moodText()
    },
    neutral () {
      return this.story.sentiment === 'neutral'
    },
    description () {
      if (this.storyEntity.freeWrite()) {
        return this.story.freeWriteDescription
      } else {
        return this.story.getInspiredDescription
      }
    },
    splittedDescription () {
      return _.split(this.description.trim(), /\r?\n/)
    },
    chipTitle () {
      if (this.storyEntity.freeWrite()) {
        return ''
      } else {
        return this.story.getInspiredQuestion
      }
    },
    dotColor () {
      if (this.goodSentiment) {
        return 'success'
      } else if (this.neutral) {
        return 'primary'
      } else {
        return 'danger'
      }
    }
  },
  methods: {
    openContextMenu () {
      // this.$root.$emit('closeAllContextMenus')

      if (this.$refs.storyCtxMenu) {
        this.$refs.storyCtxMenu.open()
      }
    },
  },
  created () {
    this.$root.$on('closeAllContextMenus', () => {
      if (this.$refs.storyCtxMenu) {
        this.$refs.storyCtxMenu.ctxVisible = false
      }
    })
  },
}
</script>

<style lang="scss">

.saved_review {
  .vx-card__header {
    padding: 0.6rem
  }
}

</style>
